import moment from "moment";
import numeral from "numeral";

export const getDataRows = (reportData) => {
  const dataRange = reportData?.map((data, index) => {
    // console.log(data);
    return {
      key: index,
      user_name: data?.user_name,
      full_name: data?.full_name,
      branch: data?.branch,
      date: data?.date,
      income: data?.income,
    };
  });
  return dataRange;
};

export const getHeaderRows = () => {
  const columns = [
    {
      title: "User Name",
      dataIndex: "user_name",
      key: "user_name",
      align: "center",
      render: (value) => <div style={{ textAlign: "left" }}>{value}</div>,
      // defaultsortorder: "descend",
      // sorter: (a, b) => a.user_name.localeCompare(b.user_name),
    },
    {
      title: "Full Name",
      dataIndex: "full_name",
      key: "full_name",
      align: "center",
      // defaultsortorder: "descend",
      render: (value) => <div style={{ textAlign: "left" }}>{value}</div>,
      sorter: {
        compare: (a, b) => a.full_name.localeCompare(b.full_name),
        multiple: 2,
      },
    },
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
      align: "center",
      // defaultsortorder: "descend",
      sorter: {
        compare: (a, b) => a.branch.localeCompare(b.branch),
        multiple: 3,
      },
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      align: "center",
      render: (value) => {
        return moment(value).format("DD/MM/YYYY");
      },
      // defaultsortorder: "descend",
      sorter: {
        compare: (a, b) => a.date - b.date,
        multiple: 1,
      },
    },
    {
      title: "Income ($)",
      dataIndex: "income",
      key: "income",
      align: "center",
      width: 220,
      render: (value) => {
        return (
          <div style={{ textAlign: "right", paddingRight: 60 }}>
            {numeral(value).format("0,0.00")}
          </div>
        );
      },
      // defaultsortorder: "descend",
      sorter: {
        compare: (a, b) => a.income - b.income,
        multiple: 4,
      },
    },
  ];
  return columns;
};
